import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import BouncedReceipt from '../../models/BouncedReceipt'

export interface BouncedReceiptListState extends PaginatedApiState {
  bouncedReceipts?: BouncedReceipt[]
}

const BouncedReceiptList = (state: BouncedReceiptListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<BouncedReceiptListState>('BOUNCED_RECEIPT_LIST')(state, action)
  }
}

export default BouncedReceiptList
